import { render, staticRenderFns } from "./FeedbacksPanel.vue?vue&type=template&id=fa12a298&scoped=true"
import script from "./FeedbacksPanel.vue?vue&type=script&lang=js"
export * from "./FeedbacksPanel.vue?vue&type=script&lang=js"
import style0 from "./FeedbacksPanel.vue?vue&type=style&index=0&id=fa12a298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa12a298",
  null
  
)

export default component.exports